import React from "react";
import PropTypes from "prop-types"; // Опечатка в импорте (propTypes -> prop-types)
import s from "./Input.module.css";

const Input = ({
  label,
  type = "text",
  placeholder = "",
  value,
  onChange,
  style,
  disabled = false,
  error,
  icon,
}) => {
  return (
    <div
      className={s.custominput}
      style={style}
    >
      {label && <label className={s.custominputlabel}>{label}</label>}
      <div className={s.custominputwrapper}>
        <input
          className={`${s.custominputfield} ${error ? s.custominputerror : ""}`}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        />
        {icon && <span className={s.custominputicon}>{icon}</span>}
      </div>
      {error && <span className={s.custominputerrormessage}>{error}</span>}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(["text", "email", "password", "number", "url", "tel"]),
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  icon: PropTypes.node,
};

// Input.defaultProps = {
//   type: "text",
//   placeholder: "",
//   value: "",
//   style: {},
//   disabled: false,
//   error: "",
//   icon: null,
// };

export default Input;
